import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { AuthService } from '../auth.service';
import { DeezerLoginPromptService } from '../shared/deezer-login-prompt.service';
import { Router, RouterLink } from "@angular/router"
import { MatCard, MatCardContent } from '@angular/material/card';
import { FormsModule } from '@angular/forms';

import { MatError, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [MatCard, MatCardContent, FormsModule, MatError, MatFormField, MatInput, MatButton, MatIcon, RouterLink]
})
export class LoginComponent implements OnInit {

  public user;
  public warning = signal<string | null>(null);
  public loading = signal(false);
  private subLogin;
  constructor(private auth: AuthService, private router: Router, private deezerPrompt: DeezerLoginPromptService) { }

  ngOnInit() {
    this.user = { userName: '', password: '' };
  }

  onSubmit() {
    console.log("logging in... " + this.user.userName + " " + this.user.password);
    if (this.user.userName.length > 0 && this.user.password.length > 0) {
      this.loading.set(true);

      this.subLogin = this.auth.login(this.user).subscribe((success) => {
        console.log('Login success:', success);
        this.loading.set(false);
        localStorage.setItem('access_token', success.token);
        this.deezerPrompt.requestAfterSignIn();
        this.router.navigate(['/new-releases']);
      },
        (err) => {
          console.error('Login error:', err);
          this.warning.set(err.error?.message || err.message || 'Unknown error occurred');
          this.loading.set(false);
        });
    }
  }
  ngOnDestroy() {
    this.subLogin?.unsubscribe();
  }
}
